// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__o919s"};